import { useStaticQuery, graphql } from "gatsby"

export const useWelcomeQuery = () => {
    const { wpPage } = useStaticQuery(
        graphql`
        query WelcomeQuery {
            wpPage(title: {eq: "Home"}) {
              welcome {
                welcomeImages {
                  welcomeImage {
                    localFile {
                      childImageSharp {
                        gatsbyImageData
                      }
                    }
                  }
                  welcomeImageAltText
                }
                welcomeHeading
                welcomeSubheading
                welcomeContent
                welcomeLink {
                  title
                  url
                }
                welcomeBackgroundImageMobile {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                  }
                }
                welcomeBackgroundImageDesktop {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                  }
                }
                welcomeBackgroundImageAltText
              }
            }
          }
        `)
return wpPage.welcome
}